import { createTheme } from "@mui/material/styles";
import tailwind from "../tailwind.config";

export const theme = createTheme({
  palette: {
    primary: {
      main: tailwind.theme.extend.colors.primary,
    },
    brand: {
      main: tailwind.theme.extend.colors.brand,
    },
    white: {
      main: tailwind.theme.extend.colors.white,
    },
    blue: {
      main: tailwind.theme.extend.colors.blue,
    },
    pink: {
      main: tailwind.theme.extend.colors.pink,
    },
    bone: {
      main: tailwind.theme.extend.colors.bone,
    },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "standard",
        color: "blue",
        fullWidth: true,
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: "standard",
        color: "blue",
      },
    },
    MuiInputLabel: {
      defaultProps: {
        variant: "standard",
        color: "blue",
      },
    },
    MuiFormHelperText: {
      defaultProps: {
        variant: "standard",
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          padding: "0.8rem",
        },
      },
      defaultProps: {
        variant: "contained",
      },
    },
    MuiLoadingButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          padding: "0.8rem",
        },
      },
      defaultProps: {
        variant: "contained",
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus":
            {
              outline: "none",
            },
        },
      },
    },
  },
});
